/** ISO 3166-1 alpha-2 → default IANA time zone for onboarding suggestions. */
export const COUNTRY_DEFAULT_TIME_ZONE: Record<string, string> = {
  CZ: 'Europe/Prague',
  SK: 'Europe/Bratislava',
  DE: 'Europe/Berlin',
  AT: 'Europe/Vienna',
  PL: 'Europe/Warsaw',
  HU: 'Europe/Budapest',
  RO: 'Europe/Bucharest',
  BG: 'Europe/Sofia',
  HR: 'Europe/Zagreb',
  SI: 'Europe/Ljubljana',
  IT: 'Europe/Rome',
  FR: 'Europe/Paris',
  ES: 'Europe/Madrid',
  PT: 'Europe/Lisbon',
  NL: 'Europe/Amsterdam',
  BE: 'Europe/Brussels',
  LU: 'Europe/Luxembourg',
  IE: 'Europe/Dublin',
  GB: 'Europe/London',
  DK: 'Europe/Copenhagen',
  SE: 'Europe/Stockholm',
  NO: 'Europe/Oslo',
  FI: 'Europe/Helsinki',
  EE: 'Europe/Tallinn',
  LV: 'Europe/Riga',
  LT: 'Europe/Vilnius',
  GR: 'Europe/Athens',
  CY: 'Asia/Nicosia',
  MT: 'Europe/Malta',
  CH: 'Europe/Zurich',
  US: 'America/New_York',
  CA: 'America/Toronto',
  UA: 'Europe/Kyiv',
};

/** Countries shown in onboarding (ISO alpha-2), sorted by label key order in locale. */
export const ONBOARDING_COUNTRY_CODES = Object.keys(COUNTRY_DEFAULT_TIME_ZONE).sort();

export function suggestedTimeZoneForCountry(countryCode: string): string {
  const upper = countryCode.trim().toUpperCase();
  return COUNTRY_DEFAULT_TIME_ZONE[upper] ?? 'UTC';
}
